import { RootState } from '../store'

const getMapDataDrawerState = (state:RootState) => state.app.mapDataDrawer.open
const getHowItWorksModalState = (state: RootState)=> state.app.howItWorksModal.open
const getwaterCoreSnapscoreModalState = (state: RootState)=> state.app.waterCoreSnapscoreModal.open
const getShareResultsModalState = (state: RootState) => state.app.shareResultsModal.open
const getIsSharedView = (state: RootState) => state.app.isSharedView

export const AppSelector = {
  getMapDataDrawerState,
  getHowItWorksModalState,
  getwaterCoreSnapscoreModalState,
  getShareResultsModalState,
  getIsSharedView
}